// extracted by mini-css-extract-plugin
export default {"formBox":"LandingPageForms_formBox__njm-g"};